import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from '../Utils/api';

export const useAllUsers = (token) => {
  return useQuery({
    queryKey: ['users', 'all'],
    queryFn: async () => {
      if (!token) return [];
      const res = await axios.get(`${API_URL}/all-users`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data || [];
    },
    enabled: !!token,
    staleTime: 1000 * 60 * 5,
  });
};

export const useUserProfile = (token, id) => {
  return useQuery({
    queryKey: ['users', 'profile', id],
    queryFn: async () => {
      if (!token || !id) return null;
      const res = await axios.get(`${API_URL}/user/${id}`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data;
    },
    enabled: !!token && !!id,
    staleTime: 1000 * 60,
  });
};

export const useSearch = (token, q, type) => {
  return useQuery({
    queryKey: ['search', q, type],
    queryFn: async () => {
      if (!token || !q?.trim() || q.trim().length < 2) return { users: [], posts: [], counts: { users: 0, posts: 0 } };
      const res = await axios.get(`${API_URL}/search`, {
        params: { q: q.trim(), type },
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data;
    },
    enabled: !!token && !!q?.trim() && q.trim().length >= 2,
    staleTime: 1000 * 60,
  });
};

export const useCurrentUser = (token) => {
  return useQuery({
    queryKey: ['users', 'current'],
    queryFn: async () => {
      if (!token) return null;
      const res = await axios.get(`${API_URL}/user_data`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data;
    },
    enabled: !!token,
    staleTime: 1000 * 60 * 10,
  });
};
